import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Text from "../../../../assets/img/admin/text.svg";
import Button from "../../../shared/Button";
import Textarea from "../../../shared/Textarea";
import AdminAdsUploadPhoto from "./AdminAdsUploadPhoto";
import photo from "../../../../assets/img/admin/image.svg";
import Input from "../../../shared/Input";
import useFetch from "../../../../hooks/useAxios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const AdmincreateAds = () => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm({});
  const [file, setfile] = useState()
  const [postData, setpostData] = useState()
 const onSubmit = data => {

    const formData = new FormData()


    formData.append("title",data.title)
    formData.append("body",data.body)
    formData.append("thumbnail",file)
    setpostData(formData)
 }
 const navigate = useNavigate()
 
 const apicreateads = useFetch({
  method: "post",
  url: `api/admin/ads/store`,
  noHeader: false,
  trigger: false,
  data: postData,
  argFunc: res => {toast.success("ایجاد پنل تبلیغاتی با موفقیت انجام شد");navigate("/admin/ads-panel")},
  errMessage:res=> toast.error("ایجاد پنل تبلیغاتی با شکست مواجه شد"),
});
useEffect(
  () => {
    if (postData) {
      apicreateads.reFetch();
    }
  },
  [postData]
);
  return (
    <div className="AdmincreateAds">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-between items-center  mb-[36px]">
          <h3 className="text-[#12171C] text-[36px] font-[700]">
            پنل های تبلیغاتی
          </h3>
          <Button varient="primary">تایید و آپلود در سایت</Button>
        </div>
        <div className="grid grid-cols-2 gap-[42px] items-center">
          <div>
            <div className="flex gap-[8px] items-center">
              <img src={Text} />
              <Input className="create-ads-input" 
                 name="title"
              control={control}
              errors={errors}
         
              rows="5"
              placeholder="  عنوان بخش را وارد کنید" />
            
            </div>
            <Textarea
              name="body"
              control={control}
              errors={errors}
              className="seconadary-input mt-[50px]"
              rows="5"
              placeholder="متن توضیحات را وارد نمایید"
            />
          </div>
          <div>
          <AdminAdsUploadPhoto
          file={file}
          setfile={setfile}
          id={10}
            description={
              <div  className="text-[#797D82] text-[18px] font-[500]  text-center">
                تصویر نمایه به عنوان تصویر کاور وبلاگ شما در صفحات سایت نشان
                دهده می شود
              </div>
            }
            uploadImg={photo}
            text={
              <div className="text-[#12171C]  text-[24px] font-[700] ">
                تصویر <span  className="text-[#00A6A6]  ">نمایه</span> را انتخاب کنید
              </div>
            }
          />
        </div>
        </div>
       
      </form>
    </div>
  );
};

export default AdmincreateAds;
